// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only. Unauthorized use,
// copying, or distribution is prohibited and may be prosecuted.

// D-CRX-82 — e-sign email controls. E-05: `api/client.ts` is frozen for new exports.

import { jsonRequest as req } from './http'

// D-CRX-82 — per document type: DocuSign copy recipients, email wording, signed-copy notice.
export type EsignDocType = 'enrollment' | 'consent' | 'pot'
export interface EsignEmailSettings {
  doc_type: EsignDocType
  cc_enabled: boolean
  cc_emails: string[]
  /** Off-domain CC addresses the admin explicitly confirmed. */
  cc_offdomain_ack: string[]
  email_subject: string | null
  email_message: string | null
  copy_enabled: boolean
  copy_emails: string[]
}
export interface EsignEmailSettingsResponse {
  pharmacy_domains: string[]
  placeholders: string[]
  limits: { addresses: number; subject: number; message: number }
  can_configure: boolean
  settings: EsignEmailSettings[]
}
export const getMyEsignSettings = () =>
  req<EsignEmailSettingsResponse>('GET', '/pharmacies/me/esign-settings')
export const putMyEsignSettings = (s: EsignEmailSettings) =>
  req<EsignEmailSettings>('PUT', '/pharmacies/me/esign-settings', s)
